import MessageBoxViewModelT from '@/ViewModels/Controls/MessageBoxViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
export default class MessageBoxViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private MessageBoxViewModel: any;
    private MessageBoxView: any;
    constructor(params: any) {
        super(params);
        this.MessageBoxViewModel = ComponentManager.getViewModel<typeof MessageBoxViewModelT>('MessageBoxViewModel');
        this.MessageBoxView = ComponentManager.getView('MessageBoxView');
    }
    public getRegion(): string {
        return 'Modal';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.MessageBoxViewModel({ viewFactory: this });
        }
        if (this.view == null) {
            this.view = new this.MessageBoxView(this.viewModel, this.createRootElement('MessageBox'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('MessageBox', MessageBoxViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');